import { render } from "./Wechat.vue.js?vue&type=template&id=1695800c!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Wechat.vue?vue&type=template&id=1695800c"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__